<template>
  <VueSwiper
    ref="swiperComponent"
    class="RcSwiper"
    :options="swiperOptions"
  >
    <VueSwiperSlide
      v-for="(item, index) in items"
      :key="index"
    >
      <slot
        name="slide"
        :item="item"
      />
    </VueSwiperSlide>
      <div
        class="swiper-pagination"
      />
      <div
        class="swiper-button-prev"

        @click.native="next()"
      />
      <div
        class="swiper-button-next"

        @click.native="prev()"
      />
  </VueSwiper>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-facing-decorator'
import Swiper from 'swiper'
import { SwiperOptions } from 'swiper/types/swiper-options'
import {
  Swiper as VueSwiper,
  SwiperSlide as VueSwiperSlide,
} from 'swiper/vue'

@Component({
  name: 'RcSwiper',
  components: {
    VueSwiper,
    VueSwiperSlide,
  },
})
export default class RcSwiper extends Vue {
  @Prop({ required: true, type: Array }) items: any[]
  @Ref() swiperComponent: any
  swiperOptions: SwiperOptions = {
    loop: true,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
    },
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 3,
      },
      980: {
        slidesPerView: 4,
      },
    },
  }

  get swiperInstance (): Swiper {
    return this.swiperComponent.$el.swiper
  }

  public next () {
    this.swiperInstance.slideNext()
  }

  public prev () {
    this.swiperInstance.slidePrev()
  }
}
</script>

<style lang="scss" src="@/assets/styles/carousel-card.scss"></style>

<style lang="scss">
</style>
